import FingerprintJS from "@fingerprintjs/fingerprintjs";
import store from "store";

/**
 * 获取浏览器指纹，用户后端唯一用户标识
 */
export const getWebFingerprint = async () => {
  if (store.get("webFingerprintId")) {
    return store.get("webFingerprintId");
  }
  const fp = await FingerprintJS.load();
  const result = await fp.get();
  const visitorId = result.visitorId + new Date().getTime();
  store.set("webFingerprintId", visitorId);
  return visitorId;
};
